import { Button } from "components/DesignSystem/Button/Button";
import { HeaderActions } from "components/AppLayout/HeaderActions";

export const PeopleOwnershipHeader = ({ onAdd }: { onAdd: () => void }) => (
  <HeaderActions>
    <Button size="small" customType="primary" onClick={onAdd}>
      + Add
    </Button>
  </HeaderActions>
);
